module.exports = __webpack_public_path__ + "static/media/processometer-two.fb932709.png";